import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { areNonCommercialFieldsEditableForUser } from "@/features/experience-curation/lib/viewTypeUtils";
import { useCurrentExperienceLocationQuery } from "@/features/experience-shared/queries/useExperienceLocationQuery";
import { useHasFunctionalNestedFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { useCityField } from "@/features/experience-shared/composables/location/useCityField";

export const useCurationCity = defineStore("curation-location-city-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const locationQuery = useCurrentExperienceLocationQuery();

  const cityCode = computed(() => locationQuery.data.value?.address?.city);
  const field = useCityField(cityCode);

  const isReadonly = computed(() => curationExperienceStore.isReadonly || !areNonCommercialFieldsEditableForUser());
  const isVisible = computed(() => !curationExperienceStore.isCommercialView);
  const hasUnpublishedChange = useHasFunctionalNestedFieldChange((f) => f?.location?.address?.city);

  return { ...field, isReadonly, isVisible, hasUnpublishedChange };
});
